import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Link } from '@ravago/shared/radiance/components/link/components/Link/Link';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { RfqStep } from '../../../../models/request-for-quotation-step';

interface Props {
   quantities: string[];
   uom: string;
   packaging?: string;
   otherPackagingDescription?: string;
   setCurrentStep: (step: RfqStep) => void;
}

export const RfqProductDetails = ({ quantities, uom, packaging, otherPackagingDescription, setCurrentStep }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column" gap="md">
         <Box direction="column" gap="2xs">
            <Typography component="span" variant="body-highlight">
               {translate('page-consumer.request-for-quotation.packaging')}
            </Typography>
            <Box gap="2xs" items="center">
               <Typography component="span" variant="body">
                  {packaging}
               </Typography>
            </Box>
         </Box>
         {otherPackagingDescription && (
            <Box direction="column" gap="2xs">
               <Typography component="span" variant="body-highlight">
                  {translate('page-consumer.request-for-quotation.packaging-description')}
               </Typography>
               <Box gap="2xs" items="center">
                  <Typography component="span" variant="body">
                     {otherPackagingDescription}
                  </Typography>
               </Box>
            </Box>
         )}
         <Box direction="column" gap="2xs">
            <Box justify="between">
               <Typography component="span" variant="body-highlight">
                  Quantities
               </Typography>
               {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
               <Link onClick={() => setCurrentStep(RfqStep.QUOTATION_DETAILS)}>Edit</Link>
            </Box>

            <Box gap="2xs" items="center">
               {quantities.map((quantity) => (
                  <Typography key={quantity + uom} component="span" variant="body">
                     <Badge variant="info" size="extra-large">{`${quantity} ${uom}`}</Badge>
                  </Typography>
               ))}
            </Box>
         </Box>
      </Box>
   );
};
